import { render, staticRenderFns } from "./purchase-list.vue?vue&type=template&id=eae9e58e&scoped=true&"
import script from "./purchase-list.vue?vue&type=script&lang=js&"
export * from "./purchase-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae9e58e",
  null
  
)

export default component.exports